
import { Component, Vue } from 'vue-property-decorator'
import Constants from '@/constants'
import axios from 'axios'
import { SchoolNoticeSlvVO, SchoolNoticeVO } from '@/views/biz/notice/vo/CalendarVO';

@Component
export default class SchoolNotices extends Vue {
  notices = [] as Array<SchoolNoticeVO>;

  created(): void {
    axios.get('/admin/notice/schools')
    .then(r=>{
      this.notices = r.data;
    })
  }
  
}
